<template>
    <div class="rd">
        <div class="pagina">
            <booking-overview v-if="locations.length > 0 && experiences.length > 0" :locations="locations" :experiences="experiences" />
            <div v-else class="leeg"><h2>Loading bookings…</h2></div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { getUserLocationsSimple } from "../../api/graphql/locations";
import { getExperiencesSimple } from "../../api/graphql/experiences";
import BookingOverview from "../booking/Overview.vue";

const locations = ref([]);
const experiences = ref([]);

const updateLocations = async () => {
    locations.value = await getUserLocationsSimple();
};

const updateExperiences = async () => {
    experiences.value = await getExperiencesSimple();
};

onMounted(() => {
    updateLocations();
    updateExperiences();
});
</script>